<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Sucursales{{ user.role === 'Administrator' ? 'del Agente ['+group+']': '' }}</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2 d-none d-lg-block">
                <b-button variant="default" :disabled="user.branch" pill block size="sm" @click="clearData" v-b-modal.partner>
                    <i class="material-icons mdi mdi-store-plus"></i>&nbsp;
                    <span>Nueva Sucursal</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="9" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay sucursales que coincidan con la búsqueda"
                    empty-text="No hay sucursales para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button :variant="(row.item.default === 1 ? '' : 'outline-') + 'default'" size="sm" title="Principal" @click="favorite(row.item.id)">
                            <i class="material-icons">star{{ row.item.default === 1 ? '' : '_outline' }}</i>
                        </b-button>
                        <b-button :variant="(row.item.activate === 1 ? 'success' : 'danger')" size="sm" :title="(row.item.activate === 1 ? 'Desa' : 'A') + 'ctivar'" @click="active(row.item.id)">
                            <i class="material-icons">visibility{{ row.item.activate === 1 ? '' : '_off' }}</i>
                        </b-button>
                        <b-button variant="primary" size="sm" title="Ver Mapa" @click="clearData(row.item.id, row.item.maps)">
                            <i class="material-icons">place</i>
                        </b-button>
                        <b-button variant="warning" size="sm" title="Editar" @click="clearData(row.item.id)" v-b-modal.partner>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <!--b-button variant="danger" size="sm" title="Eliminar" @click="trash(row.item.id)">
                            <i class="material-icons">delete</i>
                        </b-button-->
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Map Viewer -->
                <b-modal
                    id="map"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: ' + form.id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <iframe :src="'https://www.google.com/maps/embed?pb=' + form.maps" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                </b-modal>

                <!-- Modal Add/Edit Branch Partner -->
                <b-modal
                    id="partner"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(form.id ? 'Editar' : 'Agregar') + ' Sucursal' + (form.id ? (' ID: ' + form.prefijo + '-' + form.Code) : '')"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formPartner" @submit.stop.prevent="form.id > 0 ? exec(form.id) : exec()">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.name+':'">
                                    <b-form-input
                                        name="name"
                                        v-model="form.name"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="name-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="name-live-feedback">{{
                                            veeErrors.first('name')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.address+':'">
                                    <b-form-input
                                        name="address"
                                        v-model="form.address"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="address-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="address-live-feedback">{{
                                            veeErrors.first('address')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.city+':'">
                                    <b-form-input
                                        name="city"
                                        v-model="form.city"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('city')"
                                        :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="city-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="city-live-feedback">{{
                                            veeErrors.first('city')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.state+':'">
                                    <b-form-input
                                        name="state"
                                        v-model="form.state"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('state')"
                                        :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="state-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="state-live-feedback">{{
                                            veeErrors.first('state')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.maps+':'">
                                    <b-form-input
                                        name="maps"
                                        v-model="form.maps"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('maps')"
                                        :data-vv-as="(labels.maps).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="maps-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="maps-live-feedback">{{
                                            veeErrors.first('maps')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <hr>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.currency_1+':'">
                                    <b-form-select
                                        name="currency_1"
                                        :options="yes_no"
                                        :value="form.currency_1"
                                        v-model="form.currency_1"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('currency_1')"
                                        :data-vv-as="(labels.currency_1).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="currency_1-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="currency_1-live-feedback">{{
                                            veeErrors.first('currency_1')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :label="labels.currency_2+':'">
                                    <b-form-select
                                        name="currency_2"
                                        :options="yes_no"
                                        :value="form.currency_2"
                                        v-model="form.currency_2"
                                        class="form-control select-center"
                                        v-validate="'required:true'"
                                        :state="validateState('currency_2')"
                                        :data-vv-as="(labels.currency_2).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="currency_2-live-feedback"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="currency_2-live-feedback">{{
                                            veeErrors.first('currency_2')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.open+':'">
                                    <b-form-input
                                        name="open"
                                        v-model="form.open"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('open')"
                                        :data-vv-as="(labels.open).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="open-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="open-live-feedback">{{
                                            veeErrors.first('open')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5"
                                          form="formPartner" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? (form.id === 0 ? 'Guardando...' : 'Actualizando...') : (form.id === 0 ? 'Guardar' : 'Actualizar' ) }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "PartnerBranch",
    props: [ 'user' ],
    data: () => ({
        group: null,
        labels: {
            prefijo: 'Código Agente',
            code: 'Código Sucursal',
            name: 'Nombre',

            address: 'Dirección',
            city: 'Ciudad',
            state: 'Estado',
            maps: 'Ubicación GPS',

            currency_1: 'Moneda Local',
            currency_2: 'Dolares',
            open: 'Horario'
        },
        form: {
            id: 0,
            prefijo: null,
            code: null,
            Code: null,
            name: null,

            address: null,
            city: null,
            state: null,
            maps: null,

            currency_1: null,
            currency_2: null,
            open: null
        },
        yes_no: [
            { text: 'Si', value: '1' },
            { text: 'No', value: '0' }
        ],
        loading: false,
        isBusy: true,
        search: '',
        fields: [
            { key: 'Code', label: 'Código Sucursal', sortable: true },
            { key: 'name', label: 'Nombre', sortable: true },
            { key: 'location', label: 'Ubicación', sortable: true },
            { key: 'currencies', label: 'Monedas', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'partnerbranchpage');
        this.group = this.$route.params.id || this.$props.user.partner;
        this.getIni();
    },
    watch: {
        'user.partner'() {
            this.getIni();
        }
    },
    methods: {
        getIni() {
            axios.get('/api/settings/partners/' + this.group + '/branch').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        favorite(id) {
            let branch = '';
            let fav = 0;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    branch = items[i].prefijo + '-' + items[i].code;
                    fav = items[i].default;
                }
            }
            if (fav === 0) {
                this.$swal({
                    title: '¿Estas seguro de usarla como sucursal principal?',
                    text: 'Sucursal: ' + branch,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, Continuar',
                    confirmButtonColor: '#28a745',
                    cancelButtonText: 'En otro momento',
                    cancelButtonColor: '#dc3545',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/settings/partners/' + this.group + '/branch/' + id + '/default').then((res) => {
                            this.$root.$bvToast.toast(res.data.msg, {
                                title: 'Notificación',
                                headerClass: 'd-none',
                                variant: res.data.status,
                                toaster: 'b-toaster-top-right',
                                autoHideDelay: 5000,
                                solid: true,
                                appendToast: true
                            });
                            if (res.data.status === 'success') {
                                this.getIni();
                            }
                        }).catch(err => {
                            this.$root.$bvToast.toast(err.response.data.errors, {
                                title: 'Notificación',
                                headerClass: 'd-none',
                                variant: 'error',
                                toaster: 'b-toaster-top-right',
                                autoHideDelay: 5000,
                                solid: true,
                                appendToast: true
                            });
                        });
                    }
                });
            }
        },
        active(id) {
            let fav = 0;
            let branch = '';
            let text = 'desactivar';
            const items = this.items;

            if (items.length > 1) {
                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        fav = items[i].default;
                        branch = items[i].prefijo + '-' + items[i].code;
                        if (items[i].activate === 0) {
                            text = 'activar';
                        }
                    }
                }

                if (fav === 0) {
                    this.$swal({
                        title: '¿Estas seguro de ' + text + ' esta sucursal?',
                        text: 'Sucursal: ' + branch,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Si, continuar',
                        confirmButtonColor: '#28a745',
                        cancelButtonText: 'En otro momento',
                        cancelButtonColor: '#dc3545',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            axios.get('/api/settings/partners/' + this.group + '/branch/' + id + '/active').then((res) => {
                                this.$root.$bvToast.toast(res.data.msg, {
                                    title: 'Notificación',
                                    headerClass: 'd-none',
                                    variant: res.data.status,
                                    toaster: 'b-toaster-top-right',
                                    autoHideDelay: 5000,
                                    solid: true,
                                    appendToast: true
                                });
                                if (res.data.status === 'success') {
                                    this.getIni();
                                }
                            }).catch(err => {
                                this.$root.$bvToast.toast(err.response.data.errors, {
                                    title: 'Notificación',
                                    headerClass: 'd-none',
                                    variant: 'error',
                                    toaster: 'b-toaster-top-right',
                                    autoHideDelay: 5000,
                                    solid: true,
                                    appendToast: true
                                });
                            });
                        }
                    });
                } else {
                    this.$root.$bvToast.toast('La sucursal principal no puede desactivarse.', {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'warning',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            } else {
                this.$root.$bvToast.toast('Debes tener varias sucursales para desactivar esta.', {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'warning',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }
        },
        clearData(id, map) {
            this.form = {
                id: 0,
                prefijo: null,
                code: null,
                name: null,

                address: null,
                city: null,
                state: null,
                maps: null,

                currency_1: null,
                currency_2: null,
                open: null
            };
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
                if (map) {
                    this.$bvModal.show('map');
                }
            }
        },
        exec(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                let url = 'add';
                if (id) {
                    url = id + '/edit';
                }
                axios.post('/api/settings/partners/' + this.group + '/branch/' + url, this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('partner');
                        this.clearData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        trash(id) {
            let branch = '';
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    branch = items[i].prefijo + '-' + items[i].code;
                }
            }

            this.$swal({
                title: '¿Estas seguro de eliminar esta sucursal?',
                text: 'Sucursal: ' + branch,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.get('/api/settings/partners/' + this.group + '/branch/' + id + '/delete').then((res) => {
                        if (res.data.status === 'success') {
                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    }
}
</script>

<style scoped>

</style>
